/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommissionConfigurationDto } from '../models';
// @ts-ignore
import type { CommissionParameterDto } from '../models';
// @ts-ignore
import type { UpdateCommissionParameterRequestDto } from '../models';
/**
 * RestCommissionConfigurationApi - axios parameter creator
 */
export const RestCommissionConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get commission parameter configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissionConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/commission-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a commission parameter
         * @param {string} category 
         * @param {string} level 
         * @param {UpdateCommissionParameterRequestDto} updateCommissionParameterRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionParameter: async (category: string, level: string, updateCommissionParameterRequestDto: UpdateCommissionParameterRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('updateCommissionParameter', 'category', category)
            // verify required parameter 'level' is not null or undefined
            assertParamExists('updateCommissionParameter', 'level', level)
            // verify required parameter 'updateCommissionParameterRequestDto' is not null or undefined
            assertParamExists('updateCommissionParameter', 'updateCommissionParameterRequestDto', updateCommissionParameterRequestDto)
            const localVarPath = `/api/commission-configuration/parameters/{category}/{level}`
                .replace('{category}', encodeURIComponent(String(category)))
                .replace('{level}', encodeURIComponent(String(level)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommissionParameterRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCommissionConfigurationApi - functional programming interface
 */
export const RestCommissionConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCommissionConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get commission parameter configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommissionConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionConfigurationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommissionConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCommissionConfigurationApi.getCommissionConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a commission parameter
         * @param {string} category 
         * @param {string} level 
         * @param {UpdateCommissionParameterRequestDto} updateCommissionParameterRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommissionParameter(category: string, level: string, updateCommissionParameterRequestDto: UpdateCommissionParameterRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionParameterDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommissionParameter(category, level, updateCommissionParameterRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCommissionConfigurationApi.updateCommissionParameter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCommissionConfigurationApi - factory interface
 */
export const RestCommissionConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCommissionConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get commission parameter configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommissionConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<CommissionConfigurationDto> {
            return localVarFp.getCommissionConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a commission parameter
         * @param {string} category 
         * @param {string} level 
         * @param {UpdateCommissionParameterRequestDto} updateCommissionParameterRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommissionParameter(category: string, level: string, updateCommissionParameterRequestDto: UpdateCommissionParameterRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommissionParameterDto> {
            return localVarFp.updateCommissionParameter(category, level, updateCommissionParameterRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCommissionConfigurationApi - interface
 */
export interface RestCommissionConfigurationApiInterface {
    /**
     * 
     * @summary Get commission parameter configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCommissionConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<CommissionConfigurationDto>;

    /**
     * 
     * @summary Update a commission parameter
     * @param {string} category 
     * @param {string} level 
     * @param {UpdateCommissionParameterRequestDto} updateCommissionParameterRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCommissionParameter(category: string, level: string, updateCommissionParameterRequestDto: UpdateCommissionParameterRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommissionParameterDto>;

}

/**
 * RestCommissionConfigurationApi - object-oriented interface
 */
export class RestCommissionConfigurationApi extends BaseAPI implements RestCommissionConfigurationApiInterface {
    /**
     * 
     * @summary Get commission parameter configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCommissionConfiguration(options?: RawAxiosRequestConfig) {
        return RestCommissionConfigurationApiFp(this.configuration).getCommissionConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a commission parameter
     * @param {string} category 
     * @param {string} level 
     * @param {UpdateCommissionParameterRequestDto} updateCommissionParameterRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCommissionParameter(category: string, level: string, updateCommissionParameterRequestDto: UpdateCommissionParameterRequestDto, options?: RawAxiosRequestConfig) {
        return RestCommissionConfigurationApiFp(this.configuration).updateCommissionParameter(category, level, updateCommissionParameterRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

